export const isCotisationUnauthorized = (cotisationId: number): boolean => {
  return unauthorizedCotisations.includes(cotisationId);
};

const unauthorizedCotisations = [
  121545,
  123435,
  123443,
  123444,
  123445,
  123454,
  123456,
  123458,
  123459,
  123460,
  123461,
  123464,
  123465,
  123466,
  123467,
  123468,
  123469,
  123470,
  123471,
  123472,
  123473,
  123474,
  123476,
  123477,
  123480,
  123481,
  123482,
  123483,
  123484,
  123485,
  123486,
  123487,
  123488,
  123489,
  123490,
  123491,
  123492,
  123493,
  123494,
  123495,
  123496,
  123497,
  123498,
  123499,
  123500,
  123501,
  123502,
  123504,
  123505,
  123506,
  123507,
  123508,
  123509,
  123510,
  123511,
  12,
  123513,
  123514,
  123515,
  123516,
  123517,
  123518,
  123519,
  123520,
  123521,
  123522,
  123523,
  123524,
  123525,
  123526,
  123528,
  123529,
  123530,
  123535,
  123536,
  123544,
  123548,
  123557,
  123558,
  123560,
  123569,
  123572,
  123573,
  123577,
  123578,
  123579,
  123581,
  123593,
  123596,
  123597,
  123598,
  123609,
  123610,
  123611,
  123614,
  123624,
  123629,
  123630,
  123631,
  123633,
  123635,
  123637,
  123641,
  123642,
  123649,
  123650,
  123651,
  123652,
  123654,
  123656,
  123662,
  123663,
  123666,
  123667,
  123671,
  123672,
  123673,
  123674,
  123676,
  123677,
  123679,
  123680,
  123681,
  123684,
  123687,
  123690,
  123691,
  123693,
  123694,
  123695,
  123697,
  123698,
  123700,
  123702,
  123703,
  123704,
  123706,
  123707,
  12,
  123713,
  123716,
  123717,
  123718,
  123719,
  123720,
  123721,
  123724,
  123727,
  123728,
  123729,
  123731,
  123733,
  123734,
  123735,
  123736,
  123738,
  123739,
  123741,
  123743,
  123744,
  123746,
  123747,
  123748,
  123749,
  123751,
  123752,
  123753,
  123754,
  123757,
  123758,
  123761,
  123763,
  123764,
  123765,
  123767,
  123768,
  123770,
  123771,
  123772,
  123773,
  123775,
  123776,
  123778,
  123779,
  123780,
  123781,
  123782,
  123783,
  123784,
  123785,
  123788,
  123789,
  123790,
  123791,
  123794,
  123796,
  123798,
  123799,
  123800,
  123801,
  123804,
  123805,
  123806,
  123809,
  123810,
  123811,
  12,
  123819,
  123820,
  123821,
  123822,
  123824,
  123826,
  123828,
  123829,
  123832,
  123834,
  123835,
  123836,
  123839,
  123840,
  123842,
  123843,
  123847,
  123851,
  123857,
  123858,
  123859,
  123860,
  123861,
  123867,
  123870,
  123871,
  123877,
  123881,
  123882,
  123884,
  123887,
  123889,
  123890,
  123891,
  123894,
  123896,
  123899,
  123900,
  123901,
  123902,
  123903,
  123904,
  123905,
  123908,
  123910,
  123915,
  123918,
  123919,
  123921,
  123932,
  123933,
  123935,
  123936,
  123938,
  123939,
  123940,
  123943,
  123946,
  123947,
  123949,
  123952,
  123955,
  123960,
  123961,
  123962,
  123963,
  123964,
  123965,
  123968,
  123969,
  123972,
  123973,
  123974,
  123976,
  123977,
  123979,
  123980,
  123981,
  123983,
  123984,
  123985,
  123992,
  123997,
  124000,
  124001,
  124002,
  124005,
  124006,
  124009,
  124010,
  124013,
  124014,
  124016,
  124017,
  124018,
  124019,
  124021,
  124022,
  124024,
  124025,
  124026,
  124029,
  124034,
  124035,
  124036,
  124041,
  124042,
  124044,
  124048,
  124049,
  124051,
  124052,
  124053,
  124055,
  124057,
  124058,
  124059,
  124060,
  124064,
  124065,
  124067,
  124068,
  124074,
  124076,
  124092,
  124093,
  124096,
  124097,
  124098,
  124105,
  124108,
  124110,
  124114,
  124116,
  124117,
  124118,
  124119,
  122,
  124131,
  124136,
  124138,
  124139,
  124142,
  124155,
  124157,
  124163,
  124165,
  124167,
  124168,
  124171,
  124181,
  124183,
  124186,
  124187,
  124201,
  124205,
  124209,
  124216,
  124219,
  124220,
  124221,
  124222,
  124238,
  124245,
];
